module.exports = __webpack_public_path__ + "mobile/img/img2-618.6d0b7929.png";